import React, { useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { Usecases } from "./components/usecases";
import { About } from "./components/about";
import { Contact } from "./components/contact";
import { getData } from "./data/locale";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
  offset: 70,
});

const App = () => {
  const landingPageData = getData();

  useEffect(() => {
    const root = document.getElementById("root");
    if (root && root.style.display === "none") {
      root.style.display = "";
    }
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <Usecases data={landingPageData.Usecases} />
      <About data={landingPageData.About} />
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default App;
